const getEnvironmentFromUrl = () => {
    const url = window.location.href.toLowerCase();

    if (url.includes('prod')) {
        return 'prod';
    } else if (url.includes('stage')) {
        return 'stage';
    }

    return 'dev';
};

export default getEnvironmentFromUrl;


// WEBPACK FOOTER //
// ./src/helpers/GetEnvironment.js